import React from 'react'
import { DashboardDataLayers } from '../../../../constants/gtm-events/gtm-events-dashboard'
import { Logo } from './mixins'
import { SITE_ID } from '../../../../constants'
import logos from '../../../../constants/header-logos'

const siteId = SITE_ID || 'BMAR'

const Component = () => {
  const logo = logos[siteId]

  const onClick = () => {
    DashboardDataLayers.clickMenuHeader('Ir a Home')
    window.open('/empresas', '_blank')
  }

  return <Logo {...logo} onClick={onClick} />
}

export default Component
